import MapBoxGL from "mapbox-gl";

export default class MapHelper {
    public static mapBox = null;

    private static defaultZoom = 13;
    private static minZoom = 10;
    private static latitude = null;
    private static longitude = null;
    private static defaultLongitude = 9.7302;
    private static defaultLatitude = 45.61527;

    public static init() {
        this.latitude = document.getElementById("MapBox").getAttribute("data-lat");
        this.longitude = document.getElementById("MapBox").getAttribute("data-long");

        this.setMap();
    }

    private static setMap() {
        MapBoxGL.accessToken = "pk.eyJ1IjoieHRyYSIsImEiOiJjanVpMWkyaTExMmRkM3pvZWh6dXlnMm14In0.N-SzKC-zRL0Zcq6E5UiNTg";
        let center = new MapBoxGL.LngLat(this.defaultLongitude, this.defaultLatitude);
        let navigationControl = new MapBoxGL.NavigationControl();
        let geolocateControl = new MapBoxGL.GeolocateControl({
            positionOptions: {
                enableHighAccurancy: true
            }
        });

        this.mapBox = new MapBoxGL.Map({
            container: "MapBox",
            zoom: this.defaultZoom,
            center: center,
            minZoom: this.minZoom
        });

        this.mapBox.setStyle("mapbox://styles/mapbox/streets-v11");

        this.mapBox.addControl(navigationControl);

        if (!isNaN(this.longitude) && !isNaN(this.latitude)) {
            this.centerMap(new MapBoxGL.LngLat(this.longitude, this.latitude));
        }
    }

    public static setMarker(latitude, longitude, popupContent) {
        return new MapBoxGL.Marker().setLngLat([longitude, latitude]).setPopup(new MapBoxGL.Popup().setHTML(popupContent)).addTo(this.mapBox);
    }

    private static centerMap(lnglat) {
        let zoom = this.defaultZoom;

        if (!lnglat) {
            lnglat = new MapBoxGL.LngLat(this.defaultLongitude, this.defaultLatitude);
            zoom = this.defaultZoom;
        }

        this.mapBox.flyTo({
            center: lnglat,
            zoom: zoom
        });
    }

    public static setBounds(markers: any) {
        let northEastLat = null,
            northEastLng = null,
            southWestLat = null,
            southWestLng = null;

        markers.forEach(function (marker) {
            let selectMarker = marker.getLngLat();

            if (northEastLat === null && northEastLng === null) {
                northEastLat = selectMarker.lat;
                northEastLng = selectMarker.lng;
            } else {
                if (selectMarker.lat > northEastLat) {
                    northEastLat = selectMarker.lat;
                }

                if (selectMarker.lng > northEastLng) {
                    northEastLng = selectMarker.lng;
                }
            }

            if (southWestLat === null && southWestLng === null) {
                southWestLat = selectMarker.lat;
                southWestLng = selectMarker.lng;
            } else {
                if (selectMarker.lat < southWestLat) {
                    southWestLat = selectMarker.lat;
                }

                if (selectMarker.lng < southWestLng) {
                    southWestLng = selectMarker.lng;
                }
            }
        });

        let bounds = new MapBoxGL.LngLatBounds(new MapBoxGL.LngLat(northEastLng, northEastLat), new MapBoxGL.LngLat(southWestLng, southWestLat));

        this.mapBox.fitBounds(bounds, {
            padding: { top: 100, bottom: 100, left: 100, right: 100 }
        });
    }
}